import React from "react";
import user from "../../images/user.png";
import { Link } from "react-router-dom";

export const Person = props => {
  const { setLoginType } = props;
  return (
    <div className="login-type">
      <Link onClick={() => setLoginType("CITIZEN")} className="last-step">
        <span>
          <img src={user} alt="مواطن / مقيم" />
        </span>
        <section className="link-content">
          <header>مواطن / مقيم</header>
        </section>
      </Link>
      <Link onClick={() => setLoginType("NON_RESIDENT")} className="last-step">
        <span>
          <img src={user} alt="غير مقيم" />
        </span>
        <section className="link-content">
          <header>غير مقيم</header>
        </section>
      </Link>
    </div>
  );
};
